/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LearningOutcomeTemplateDTO,
    LearningOutcomeTemplateDTOFromJSON,
    LearningOutcomeTemplateDTOFromJSONTyped,
    LearningOutcomeTemplateDTOToJSON,
} from './LearningOutcomeTemplateDTO';

/**
 * 
 * @export
 * @interface ScienceBranchDTO
 */
export interface ScienceBranchDTO {
    /**
     * 
     * @type {string}
     * @memberof ScienceBranchDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ScienceBranchDTO
     */
    readonly name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScienceBranchDTO
     */
    fundamentalDomainId?: string;
    /**
     * 
     * @type {string}
     * @memberof ScienceBranchDTO
     */
    completeName?: string | null;
    /**
     * 
     * @type {Array<LearningOutcomeTemplateDTO>}
     * @memberof ScienceBranchDTO
     */
    learningKnowledgeOutcome?: Array<LearningOutcomeTemplateDTO> | null;
    /**
     * 
     * @type {Array<LearningOutcomeTemplateDTO>}
     * @memberof ScienceBranchDTO
     */
    learningSkillOutcome?: Array<LearningOutcomeTemplateDTO> | null;
    /**
     * 
     * @type {Array<LearningOutcomeTemplateDTO>}
     * @memberof ScienceBranchDTO
     */
    learningResponsabilityOutcome?: Array<LearningOutcomeTemplateDTO> | null;
}

export function ScienceBranchDTOFromJSON(json: any): ScienceBranchDTO {
    return ScienceBranchDTOFromJSONTyped(json, false);
}

export function ScienceBranchDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScienceBranchDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'fundamentalDomainId': !exists(json, 'fundamentalDomainId') ? undefined : json['fundamentalDomainId'],
        'completeName': !exists(json, 'completeName') ? undefined : json['completeName'],
        'learningKnowledgeOutcome': !exists(json, 'learningKnowledgeOutcome') ? undefined : (json['learningKnowledgeOutcome'] === null ? null : (json['learningKnowledgeOutcome'] as Array<any>).map(LearningOutcomeTemplateDTOFromJSON)),
        'learningSkillOutcome': !exists(json, 'learningSkillOutcome') ? undefined : (json['learningSkillOutcome'] === null ? null : (json['learningSkillOutcome'] as Array<any>).map(LearningOutcomeTemplateDTOFromJSON)),
        'learningResponsabilityOutcome': !exists(json, 'learningResponsabilityOutcome') ? undefined : (json['learningResponsabilityOutcome'] === null ? null : (json['learningResponsabilityOutcome'] as Array<any>).map(LearningOutcomeTemplateDTOFromJSON)),
    };
}

export function ScienceBranchDTOToJSON(value?: ScienceBranchDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'fundamentalDomainId': value.fundamentalDomainId,
        'completeName': value.completeName,
        'learningKnowledgeOutcome': value.learningKnowledgeOutcome === undefined ? undefined : (value.learningKnowledgeOutcome === null ? null : (value.learningKnowledgeOutcome as Array<any>).map(LearningOutcomeTemplateDTOToJSON)),
        'learningSkillOutcome': value.learningSkillOutcome === undefined ? undefined : (value.learningSkillOutcome === null ? null : (value.learningSkillOutcome as Array<any>).map(LearningOutcomeTemplateDTOToJSON)),
        'learningResponsabilityOutcome': value.learningResponsabilityOutcome === undefined ? undefined : (value.learningResponsabilityOutcome === null ? null : (value.learningResponsabilityOutcome as Array<any>).map(LearningOutcomeTemplateDTOToJSON)),
    };
}

